import { Stack, StackProps } from "@mui/material";
import { COLORS } from "style";

export const HospitalRouteItemContainer = (props: StackProps) => {
  return (
    <Stack
      sx={{
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        border: `1px solid ${COLORS.DISCO_BALL}`,
        borderRadius: "4px",
        bgcolor: COLORS.WHITE,
        py: 1,
        px: "12px",
      }}
      {...props}
    />
  );
};
